export default __webpack_public_path__ + "static/media/sales.10d2a586.PNG";